module.exports = __webpack_public_path__ + "static/media/image3.34a453eb.jpg";